import { Modal, List, Typography, Alert } from 'antd';

const TagsInfoModal = ({ visible, onClose, tags }) => {
    return (
        <div style={{ maxHeight: 500, overflow: 'auto' }}>
            <Modal
                getContainer={false}
                title="Tags Permitidas"
                open={visible}
                onCancel={onClose}
                width={700}
                footer={null}
                centered
            >
                <Typography.Paragraph>
                    As tags listadas abaixo devem ser usadas exatamente como estão, incluindo os caracteres # no início e no fim.
                    Qualquer modificação no formato das tags ou o uso de tags não listadas resultará na rejeição do cadastro ou atualização do template pelo sistema.
                    Essas tags serão automaticamente substituídas pelos valores correspondentes durante as principais ações de uma solicitação.
                </Typography.Paragraph>

                <div className='mb-3 me-2'>
                    <Alert
                        type="info"
                        showIcon
                        message="A tag de link da solicitação é gerada automaticamente pelo sistema em todos os templates, exceto o de comunicado."
                        className="mt-3"
                    />
                </div>

                <List
                    bordered
                    dataSource={tags}
                    renderItem={({ tag, description }) => (
                        <List.Item>
                            <Typography.Text style={{ color: '#2b97be' }}>
                                <strong>{`#${tag}#`}</strong>
                            </Typography.Text> — {description}
                        </List.Item>
                    )}
                />
            </Modal>
        </div>
    );
};

export default TagsInfoModal;